module.exports = true;


/*****************
 ** WEBPACK FOOTER
 ** c:/Users/martin.nikl/Desktop/SA GITLAB/frontend/~/babel-runtime/~/core-js/library/modules/_library.js
 ** module id = 28
 ** module chunks = 0 1 2 3
 **/